import React, { PureComponent } from 'react';

import styles from './styles.less';
import Icon from '~/UI/Icon';

interface Props {
	style: React.CSSProperties;
}

export default class Header extends PureComponent<Props> {
	public static defaultProps = {
		style: null,
	};

	public render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>
					Price
					<span
						className={styles.parameterIcon}
						title={`Lower Price (in bold): Original price published in the data source (either Ex-factory price or price used per Ex-factory price calculation)\nUpper Price: Ex-factory price (either published or calculated)`}
					>
						<Icon name='violet-question-mark' />
					</span>
				</div>
				<div className={styles.packageForCalculationCell}>Package for calc.</div>
				<div
					className={styles.priceCell}
					title={`Calc. price: Price calculated by multiplying price (in the Price field) by package size (in the Package for calc. field)\nLower Price (in bold): Original price published in the data source (either Ex-factory price or price used per Ex-factory price calculation)\nUpper Price: Ex-factory price (either published or calculated)`}
				>
					Calc. Price
					<span className={styles.parameterIcon}>
						<Icon name='violet-question-mark' />
					</span>
				</div>
				<div className={styles.selectionCell}>Use for calc.</div>
				<div className={styles.usedForCalculationCell} />
			</div>
		);
	}
}
